<template>
  <div class="IndustryList">
    <div class="IndustryList-box">
      <!-- 列表 -->
      <div class="IndustryList-content">
        <!-- 列表项 -->
        <template v-for="(item, index) in industryList">
          <div class="IndustryList-item"  :key="index" >
            <div class="IndustryList-item-title">
              <!-- 列表项文字 -->
              <div class="name">{{ item.name }}</div>
              <div class="more"><a :href="`/search?oneCategoryType=${item.id}`" target="_blank" >更多方案 <span class="iconfont icon-arrowright"></span></a></div>
            </div>
            <div class="IndustryList-list">
                <template v-for="(ite,index) in item.children">

               <a v-if="index < 15"  :href="`/search?oneCategoryType=${item.id}&secondCategoryType=${ite.id}`" target="_blank" ><div class="list-item" :key="ite.name">{{ ite.name }}</div></a>
            </template>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { restCategoryList } from "@/services/search";

export default {
  name: "IndustryList",
  components: {
    // [Button.name]: Button // 此处是引入组件名字的方法
  },
  data() {
    return {
      industryList: [],
      loading:true,
    };
  },
  created() {
    this.getlist();
  },
  mounted() {},
  methods: {
    async getlist() {
      let data = [];
      let list = await restCategoryList({
        level: 1,
      }).then((res) => res.data);
      this.loading=false
      list.forEach(async (p, ind) => {
        const list2 = await restCategoryList({
          level: 2,
          parentId: p.id,
        }).then((res) => res.data);
        list2.forEach((s) => (s.name = s.categoryName));
        p.name = p.categoryName;
        p.children = list2;
        data.push(p);
      });
      this.industryList = data;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/config.scss";

.IndustryList {
  background-color: #fff;
  padding: 24px 0;
  .IndustryList-box {
    width: $layout-body-width;
    margin: 0 auto;
    color: #282828;
  }
  .IndustryList-content {
    display: flex;
    justify-content: space-between;
    .IndustryList-item {
      width: 384px;
      border-radius: 8px 8px 6px 6px;
      border: 1px solid #eeeeee;
      border-top: 0;
      .IndustryList-item-title {
        height: 57px;
        padding: 0 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          font-size: 18px;
          font-weight: 550;
          padding-left: 24px;
        }
        .more {
          width: 92px;
          height: 24px;
          background: #ffffff;
          border-radius: 12px;
          line-height: 24px;
          text-align: center;
          font-weight: 600;
          cursor: pointer;

          span {
            font-size: 10px;
            position: relative;
            top: -1px;
          }
        }
      }
      &:first-child {
        .IndustryList-item-title {
          background: url("@/assets/img/home/Industry-t-bg1.png");
          background-size: cover;
          color: #2357f5;
          .name {
            background: url("@/assets/img/home/Industry-t-icon1.png") no-repeat center left;
            background-size: 16px 16px;
          }
          a{
            color: #2357f5;
          }
        }
      }
      &:nth-child(2) {
        .IndustryList-item-title {
          background: url("@/assets/img/home/Industry-t-bg2.png");
          background-size: cover;
          color: #ff7c00;
          a{
            color: #ff7c00;
          }
          .name {
            background: url("@/assets/img/home/Industry-t-icon2.png") no-repeat center left;
            background-size: 16px 16px;
          }
        }
      }
      &:nth-child(3) {
        .IndustryList-item-title {
          background: url("@/assets/img/home/Industry-t-bg3.png");
          background-size: cover;
          color: #ff3535;
          a{
            color: #ff3535;
          }
          .name {
            background: url("@/assets/img/home/Industry-t-icon3.png") no-repeat center left;
            background-size: 16px 16px;
          }
        }
      }
      .IndustryList-list {
        padding: 24px 24px 4px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .list-item {
          width: 104px;
          height: 32px;
          line-height: 20px;
          background: #f6f6f6;
          border-radius: 4px;
          padding-top: 6px;
          text-align: center;
          margin-bottom: 20px;
          cursor: pointer;
          &:hover {
            font-weight: 600;
          }
        //   &:active {
        //     background: #2357f5;
        //     color: #fff;
        //     font-weight: 600;
        //   }
        }
      }
    }
  }
}
</style>
